<script setup lang="ts">
import { reactive, ref, toRaw } from 'vue';

import KBtn from '@/components/btns/KBtn.vue';
import StateSelectField from '@/components/fields/StateSelectField.vue';
import DatePickerField from '@/components/pickerFields/DatePickerField.vue';
import useForm from '@/composables/useForm';
import { requiredValidationRule } from '@/helpers/validationRules';

export interface InitialData {
  division?: string;
  date?: string;
}

export interface ValidData {
  division: string;
  date: string;
}

export interface Props {
  loading?: boolean;
  initialData?: InitialData;
}
const props = withDefaults(defineProps<Props>(), {
  loading: false,
  initialData: () => ({}),
});
const emit = defineEmits<{
  submit: [formData: ValidData];
}>();

const formData = reactive<InitialData>({});
const isValid = ref(true);

const { form, handleSubmit } = useForm(props, formData, () => {
  emit('submit', toRaw(formData) as ValidData);
});
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    validate-on="lazy"
    :class="$style.tomorrowReportSearchForm"
    data-testid="tomorrowReportSearchForm"
    @submit.prevent="handleSubmit"
  >
    <DatePickerField
      v-model="formData.date"
      size="lg"
      label="Date"
      :disabled="props.loading"
      :rules="[requiredValidationRule]"
      :class="$style.field"
    />
    <StateSelectField
      v-model="formData.division"
      size="large"
      :disabled="props.loading"
      :rules="[requiredValidationRule]"
      :class="$style.field"
      @keydown.enter="handleSubmit"
    />
    <KBtn
      type="submit"
      size="lg"
      prepend-icon="mdi-magnify"
      :loading="props.loading"
      :class="$style.submit"
    >
      Search
    </KBtn>
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.tomorrowReportSearchForm {
}
  .field {
    width: 17.5rem;
    display: inline-block;
    vertical-align: top;
  }
  .field {
    margin-right: 1.5rem;
    margin-bottom: 0.5rem;
  }
  .submit {
    margin-bottom: calc(0.5rem + 22px);
  }
</style>
